<template>
    <div class="article-item-wrap">
        <div class="category-head"><a href="/#!/product-detail/{{itemData.id}}"><h3>{{ itemData.category }}</h3></a></div>
        <div class="image-wrap">
            <a href="/#!/product-detail/{{itemData.id}}"><img class="img" :src="itemData.image" style="width: 142px;"></a>
        </div>
        <div class="details-wrap">
            <span class="article-name">{{ itemData.name }}</span>
            <div class="stars-wrap">
                <div class="star" v-for="n in 5" :key="n">
                    <img  v-if="itemData.stars < n" src="../../assets/images/empty-star.png">
                    <img  v-else src="../../assets/images/star.png">
                </div>
            </div>
            <div class="price-wrap button--state-success__dark">
                <span class="currency-wrap">RD$</span>
                <span class="price-value">{{ itemData.price | currency }}</span>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    name: 'market-hotel-item',
    props: {
        itemData: Object
    }
}
</script>

<style scoped>
    .article-item-wrap {
        background-color: #fff;
        border: 1px solid #ddd;
        padding: 20px;
        border-radius: 3px;
        display: flex;
        flex-flow: column wrap;
        width: 100%;
        min-width: 284px;
        margin: 0 5px 10px 5px;
    }

     .article-item-wrap:nth-child(3n+1) {
        margin-left: 0;

         @media (max-width: 1270px) {
           margin-left:5px;
           margin-right:5px;
        }
    }

    .article-item-wrap:nth-child(3n+3),
    .article-item-wrap:last-child {
         margin-right: 0;

         @media (max-width: 1270px) {
           margin-left:5px;
           margin-right:5px;
        }
    }

    .category-head h3 {
        text-align: center;
        margin-top: 0;
        font-weight: lighter;
    }

    .image-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 200px;
    }

    .image-wrap img {
        width: 100%;
        height: auto;
    }

    .details-wrap {
        flex: 1;
        padding-top: 15px;
        display: flex;
        align-items: center;
        flex-flow: column;
    }

    .stars-wrap {
        display: flex;
        margin: 5px 0;
    }

    .stars-wrap img {
        width: 10px;
        height: 10px;
        margin-right: 3px;
    }

    span.article-name {
        font-size: 13px;
    }

    .price-wrap {
        display: flex;
    }

    .currency-wrap {
        display: flex;
        align-items: center;
        font-size: 9px;
    }

    .price-value {
        margin: 0 3px;
    }
    
    .price-decimals {
        display: flex;
        align-items: flex-end;
        font-size: 9px;
    }

    @media (max-width: 1250px) {
        .article-item-wrap {
            margin-left:5px;
           margin-right:5px;
        }
    }

    @media (max-width: 1270px) {
        .article-item-wrap:nth-child(3n+1) {
           margin-left:5px;
           margin-right:5px;
        }

        .article-item-wrap:nth-child(3n+3),
        .article-item-wrap:last-child {
            margin-left:5px;
            margin-right:5px;
        }
    }
</style>


// WEBPACK FOOTER //
// market-hotel-item.vue?58d24774